module.exports = __webpack_public_path__ + "static/media/SLT_500.644fb047.png";